import { Entry, GuestbookEvent, Invitation } from '@/shared/types'
import { AuthenticationService } from './AuthService'
import { CreateEventInput, createEvent } from './useCases/createEvent'
import { deleteEvent } from './useCases/deleteEvent'
import { getEvent } from './useCases/getEvent'
import { listEvents } from './useCases/listEvents'
import { S3Client } from '@aws-sdk/client-s3'
import { UpdateEventInput, updateEvent } from './useCases/updateEvent'
import { CreateEntryInput, createEntry } from './useCases/createEntry'
import { listEntries } from './useCases/listEntries'
import { UpdateWelcomeInput, updateWelcome } from './useCases/updateWelcome'
import { UpdateClosingInput, updateClosing } from './useCases/updateClosing'
import {
  UpdateInvitationInput,
  updateInvitation,
} from './useCases/updateInvitation'
import { getInvitation } from './useCases/getInvitation'

export class GuestbookClient {
  auth: AuthenticationService
  s3Client?: S3Client

  constructor(auth: AuthenticationService) {
    this.auth = auth
  }

  public async createEvent(input: CreateEventInput): Promise<string> {
    return await createEvent.call(this, input)
  }

  public async listEvents(): Promise<GuestbookEvent[]> {
    return await listEvents.call(this)
  }

  public async getEvent(id: string): Promise<GuestbookEvent | undefined> {
    return await getEvent.call(this, id)
  }

  public async deleteEvent(id: string): Promise<void> {
    return await deleteEvent.call(this, id)
  }

  public async updateEvent(input: UpdateEventInput): Promise<string> {
    return await updateEvent.call(this, input)
  }

  public async updateWelcome(input: UpdateWelcomeInput): Promise<string> {
    return await updateWelcome.call(this, input)
  }

  public async updateClosing(input: UpdateClosingInput): Promise<string> {
    return await updateClosing.call(this, input)
  }

  public async createEntry(input: CreateEntryInput): Promise<string> {
    return await createEntry.call(this, input)
  }

  public async listEntries(eventId: string): Promise<Entry[]> {
    return await listEntries.call(this, eventId)
  }

  public async updateInvitation(input: UpdateInvitationInput): Promise<string> {
    return await updateInvitation.call(this, input)
  }

  public async getInvitation(eventId: string): Promise<Invitation | undefined> {
    return await getInvitation.call(this, eventId)
  }
}
